














import { onMounted, toRefs } from '@vue/composition-api';
import { getDefaultRouteByRole } from '@/router';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import AuthLayout from '@/views/AuthViews/AuthLayout.vue';

export default {
  name: 'AuthOauth',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  components: {
    AuthLayout
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props: { status: 'success' | 'failure' }, context): void {
    const { status } = toRefs(props);

    const router = context.root.$router;
    const store = context.root.$store;
    const toast = context.root.$toast;
    const role = context.root.$role;

    const getUrlParamsAndClear = (): {
      token: string;
      isMfaRequired: boolean;
      error: string | null;
      mfaSetup: boolean;
    } => {
      const url = new URL(window.location.href);

      const getTokenFromUrl = (): string => {
        const token = url.searchParams.get('token') || '';

        if (!token || typeof token !== 'string') {
          return '';
        }

        return token;
      };

      const getIsMfaRequiredFromUrl = (): boolean => {
        return url.searchParams.get('mfaRequired') === 'true';
      };

      const getIsMfaSetupFromUrl = (): boolean => {
        return url.searchParams.get('mfaSetup') === 'true';
      };

      const getErrorFromUrl = (): string | null => {
        return url.searchParams.get('error') || null;
      };

      const clearUrlParams = (): void => {
        url.searchParams.delete('token');
        url.searchParams.delete('mfaRequired');

        window.history.replaceState({}, document.title, url.toString());
      };

      const token = getTokenFromUrl();
      const isMfaRequired = getIsMfaRequiredFromUrl();
      const error = getErrorFromUrl();
      const mfaSetup = getIsMfaSetupFromUrl();

      clearUrlParams();

      return {
        token,
        mfaSetup,
        isMfaRequired,
        error
      };
    };

    onMounted(() => {
      const { token, isMfaRequired, error, mfaSetup } =
        getUrlParamsAndClear();

      if (status.value !== 'success') {
        toast.error(
          error || 'Something went wrong during social authorization'
        );
        router.push({ name: 'login' });

        return;
      }

      if (!token) {
        router.push({ name: 'login' });

        return;
      }

      if (isMfaRequired) {
        store.commit('Auth/mfa', {
          mfaToken: token,
          mfaSetup
        });
        router.push({ name: 'login' });

        return;
      }

      store.dispatch('Auth/authorize', token);
      router.push(getDefaultRouteByRole(role.name)).catch(errorToastMessage);
    });
  }
};
